<style lang="scss">
  @use "../../../components/shared/tab-body.scss";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_colors.scss"
    as colors;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils.scss"
    as utils;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_mixins.scss"
    as mixins;

  .contact-fields {
    padding: 0;

    .notice {
      margin-top: utils.in_rem(16px);
      margin-bottom: utils.in_rem(16px);
      p {
        @include mixins.body2();
        a {
          text-decoration-line: underline;
          text-decoration-style: solid;
          text-decoration-skip-ink: none;
          text-decoration-thickness: auto;
          text-underline-offset: auto;
          text-underline-position: from-font;
        }
      }
    }
  }
</style>

<script>
  import InlineNotification from "@sourcewhale/shared/svelte-design-system/components/atoms/InlineNotification.svelte";
  import CustomTabs from "../../../components/shared/CustomTabs.svelte";
  import FieldsMapping from "../../../components/shared/FieldsMapping.svelte";
  import TabContent from "../../../components/shared/TabContent.svelte";
  import { integrationStore } from "../../../stores";

  const syncKinds = $integrationStore.getSyncKinds();

  const tabItems = syncKinds.map((kind, index) => ({
    label: ($integrationStore.getSyncAsLabelMap()[kind] || kind).toUpperCase(),
    slot: `tab${index}`,
    kind,
  }));

  let currentType;
</script>

<div class="contact-fields tab-body">
  <div class="notice">
    <InlineNotification>
      <p>
        These settings are <b>optional</b> and apply only to Data Refresh. By default,
        refreshed data will follow your main field mappings. Use this section only
        if you want refreshed data to update custom fields instead.
      </p>
    </InlineNotification>
  </div>

  <CustomTabs {tabItems} bind:currentType />
  <TabContent
    hasData={true}
    tabCount={tabItems.length}
    emptyMessage="No field mappings available for this type."
  >
    <FieldsMapping syncAs={$currentType} />
  </TabContent>
</div>
